interface FormatInputMoneyWithDecimalOptions {
  reset?: boolean;
}

const formatInputMoneyWithDecimal = (
  val: any,
  maxDecimal?: number,
  currencyCode?: string,
  options?: FormatInputMoneyWithDecimalOptions
): string | number => {
  const isIdr = !currencyCode || String(currencyCode).toUpperCase() === "IDR";

  if (options?.reset) {
    const isIdrCurrency = isIdr;
    const s = (val ?? "").toString().trim();
    if (s === "") return 0;
    let normalized = s;
    if (isIdrCurrency) {
      if (s.includes(",")) {
        normalized = s
          .split(".")
          .join("")
          .replace(",", ".");
      } else if (/^\d{1,3}(\.\d{3})+$/.test(s)) {
        normalized = s.split(".").join("");
      }
    } else {
      if (s.includes(".")) {
        normalized = s.split(",").join("");
      } else if (/^\d{1,3}(,\d{3})+$/.test(s)) {
        normalized = s.split(",").join("");
      }
    }
    const num = parseFloat(normalized);
    return Number.isFinite(num) ? num : 0;
  }

  if (typeof val === "number") {
    val = val.toString().replace(".", isIdr ? "," : ".");
  }
  val = val.toString();
  if (val === "") return val;

  if (!isIdr) {
    const splitVal = val.split(".");

    val = val
      .replace(/[^0-9.]+/g, "")
      .replace(/^\.$/g, "")
      .replace(/\.+/g, ".")
      .replace(/\.(\d+)\./g, ".$1");

    const lastMaxDecimal =
      maxDecimal && maxDecimal - 1
        ? `.${Array(maxDecimal - 1)
            .fill("0")
            .join("")}`
        : "";
    const splitValMaxDecimal =
      maxDecimal && splitVal[1]?.match(/0/g)?.length >= maxDecimal
        ? `${splitVal[0]}${lastMaxDecimal}`
        : val;

    if (parseInt(splitVal[1])) {
      const rounded = parseFloat(val).toLocaleString("en", {
        maximumFractionDigits: maxDecimal
      });
      return rounded.includes("NaN") ? val : rounded;
    }

    val = splitValMaxDecimal || val;
    const parts = val.split(".");
    const groupedInt = parseFloat(parts[0] || "0").toLocaleString("en", {
      maximumFractionDigits: 0
    });
    const safeInt = groupedInt.includes("NaN") ? parts[0] || "" : groupedInt;
    return parts.length > 1 ? `${safeInt}.${parts.slice(1).join("")}` : safeInt;
  }

  const splitVal = val.split(",");

  val = val
    .replace(/[^0-9,]+/g, "")
    .replace(/^,$/g, "")
    .replace(/,+/g, ",")
    .replace(/,(\d+),/g, ",$1");

  const lastMaxDecimal =
    maxDecimal && maxDecimal - 1
      ? `,${Array(maxDecimal - 1)
          .fill("0")
          .join("")}`
      : "";
  const splitValMaxDecimal =
    maxDecimal && splitVal[1]?.match(/0/g)?.length >= maxDecimal
      ? `${splitVal[0]}${lastMaxDecimal}`
      : val;

  val = !parseInt(splitVal[1])
    ? splitValMaxDecimal
    : val.replace(/,(\d+)/g, ".$1");
  const splitFirst = `,${val.split(",")[1]}`;
  const formatMoney = `${parseFloat(val.split(",")[0]).toLocaleString("id", {
    maximumFractionDigits: maxDecimal
  })}${val.split(",")[1] !== undefined ? splitFirst : ""}`;
  const validFormatMoney = !formatMoney.includes("NaN") ? formatMoney : val;
  return val ? validFormatMoney : val;
};
export default formatInputMoneyWithDecimal;
